import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=fa2d1c56&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style0 from "./MainPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainPage.vue?vue&type=style&index=1&id=fa2d1c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2d1c56",
  null
  
)

export default component.exports